"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LAMBDA_TIMEOUT = exports.DEFAULT_ADDRESS = exports.defaultUserJson = void 0;
exports.defaultUserJson = {
    assets: {
        backgrounds: [],
        characters: [],
    },
    storiesData: {
        storiesListing: {},
    },
};
exports.DEFAULT_ADDRESS = '0x0';
exports.DEFAULT_LAMBDA_TIMEOUT = 2000;
//# sourceMappingURL=defaults.js.map